import { z } from 'zod';

const optionalString = (minLength?: number, message?: string) =>
  z
    .union([z.string(), z.null(), z.undefined()])
    .transform((val) => (val === '' ? null : val))
    .refine(
      (val) =>
        val === null ||
        val === undefined ||
        (typeof val === 'string' &&
          (minLength ? val.length >= minLength : true)),
      { message: message ?? `Must be at least ${minLength} characters` }
    );

export const basicConfigurationSchema = z.object({
  name: optionalString(3, 'validation.min.name.3'),
  legalStatus: optionalString(),
  street: optionalString(),
  buildingNumber: optionalString(),
  flatNumber: optionalString(),
  city: optionalString(),
  postalCode: optionalString(),
  post: optionalString(),
  nip: optionalString(),
  email: optionalString().refine(
    (val) =>
      val === null ||
      val === undefined ||
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val),
    { message: 'validation.invalid.email' }
  ),
});
